export { PagerComponent } from './pager.component';
export { PaginationComponent } from './pagination.component';
export { PaginationModule } from './pagination.module';
export { PaginationConfig } from './pagination.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/ngx-bootstrap/pagination/index.js
// module id = ../../../../ngx-bootstrap/pagination/index.js
// module chunks = 8